import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import DataNumberIcon from '@atlaskit/icon/core/data-number';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.jira-number-field.icon-label',
		defaultMessage: 'Number field icon',
		description:
			'Accessible label for the icon representing the number field in a Jira work item action card.',
	},
});

export function NumberFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<DataNumberIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
